var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserphoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3933_1922)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 17C23 18.6569 21.6569 20 20 20C18.3431 20 17 18.6569 17 17C17 15.3431 18.3431 14 20 14C21.6569 14 23 15.3431 23 17ZM25 17C25 19.7614 22.7614 22 20 22C17.2386 22 15 19.7614 15 17C15 14.2386 17.2386 12 20 12C22.7614 12 25 14.2386 25 17ZM15.0245 22.2903C15.1628 22.1835 15.3303 22.1177 15.505 22.1118C16.016 22.0945 16.2756 22.2136 16.4752 22.4393C16.8604 22.8748 16.6072 23.5818 16.1542 23.9462C15.3213 24.616 14.6773 25.4973 14.306 26.4998H25.693C25.3218 25.4975 24.678 24.6164 23.8454 23.9466C23.3924 23.5822 23.1394 22.875 23.5246 22.4395C23.7243 22.2137 23.9838 22.0947 24.4948 22.1121C24.6693 22.1181 24.8368 22.1839 24.975 22.2906C26.5963 23.5427 27.7152 25.3928 27.9862 27.502C28.0566 28.0498 27.6021 28.4998 27.0499 28.4998H12.9492C12.3969 28.4998 11.9424 28.0498 12.0128 27.502C12.2839 25.3927 13.403 23.5424 15.0245 22.2903Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3933_1922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserphoto);
export default __webpack_public_path__ + "static/media/userphoto.e5cb8f7135d99becdc7a510341fb6f04.svg";
export { ForwardRef as ReactComponent };